// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DaS2frE6ILmZ3\\+M3aRV\\+Lw\\=\\= .Select-loading-zone{display:none}", "",{"version":3,"sources":["webpack://client_react/src/components/Select/Select.styl"],"names":[],"mappings":"AACE,mDAIE,YAAS","sourcesContent":[":local(.global) {\n  .Select-loading-zone {\n    // Since the Async Selector is used for windowing,\n    // we can expect results almost instantaneously.\n    // We should therefore not 'flash' the loading spinner\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"global": "DaS2frE6ILmZ3+M3aRV+Lw=="
};
module.exports = ___CSS_LOADER_EXPORT___;
